import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Card, Label } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'expert-card'

/**
 * This is the component description.
 */
const ExpertCard = ({
  id,
  className:userClassName,
  style,
  name,
  identifier,
  location,
  image,
  role,
  languages,
  tags,
  stats,
  // ...otherProps
}) => (
  <Card
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    <Card.Section className="image-section">
      {image && <img src={image} alt={`${name}, ${role}`} draggable="false" />}
    </Card.Section>
    <Card.Section>
      <div className="details">
        <div className="person">
          <p className="name h2">{name}</p>
          <p className="identifier">{identifier}</p>
        </div>
        <p className="role x-highlighted c-x">
          {role}
        </p>
        <p className="location">
          {location}
        </p>
      </div>
      <div>
        {languages && (
          <div className="languages">
            {languages.map((language) => (
              <Label color="main2" isCompact>
                {language}
              </Label>
            ))}
          </div>
        )}
      </div>
      <div>
        {tags && (
          <div className="tags">
            {tags.map((tag) => (
              <Label color="background-near" isCompact>
                {tag}
              </Label>
            ))}
          </div>
        )}
      </div>
      <div>
        {stats && (
          <div className="stats">
            {stats.map(({ label, value }) => (
              <div className="stat">
                <p className="label h3">{label}</p>
                <p className="value h3">{value}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </Card.Section>
  </Card>
)

ExpertCard.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The person's image
  */
  image:PropTypes.string.isRequired,

  /**
   * The person's name
   */
  name:PropTypes.string.isRequired,

  /**
   *  The person's role
   */
  role:PropTypes.string.isRequired,

  /**
   * The person's identifier string
   */
  identifier:PropTypes.string.isRequired,

  /**
   * The person's location
   */
  location:PropTypes.string.isRequired,

  /**
   * The person's languages
   */
  languages:PropTypes.arrayOf(PropTypes.string).isRequired,

  /**
   * The person's tags
   */
  tags:PropTypes.arrayOf(PropTypes.string).isRequired,

  /**
   * The person's stats
   */
  stats:PropTypes.arrayOf(PropTypes.shape({
    label:PropTypes.string.isRequired,
    value:PropTypes.string.isRequired,
  })).isRequired,
}

ExpertCard.defaultProps = {
//
}

ExpertCard.Group = Card.Group

export default ExpertCard
